// src/components/ActionPanel.js
import React from 'react';
import { useGame } from '../contexts/GameContext';
import './ActionPanel.css';

function ActionPanel({ disabled }) {
  const {
    selectedCards,
    gameState,
    takeOneCard,
    takeAllCamels,
    exchangeCards,
    sellCards,
    clearSelection
  } = useGame();

  const canTakeOne = selectedCards.market.length === 1 && selectedCards.hand.length === 0 && selectedCards.camels.length === 0;
  const canTakeAllCamels = selectedCards.market.length === 0 && selectedCards.hand.length === 0 && selectedCards.camels.length === 0;
  const canExchange = selectedCards.market.length > 0 &&
                      (selectedCards.hand.length + selectedCards.camels.length) === selectedCards.market.length;
  const canSell = selectedCards.hand.length > 0 && selectedCards.market.length === 0 && selectedCards.camels.length === 0;

  const handleTakeOne = () => {
    if (canTakeOne && !disabled) {
      const marketCard = gameState.market[selectedCards.market[0]];
      if (marketCard.type === 'camel') {
        alert('不能用拿取一张卡牌的操作拿骆驼！请使用"拿取所有骆驼"操作。');
        return;
      }
      takeOneCard(selectedCards.market[0]);
      clearSelection();
    }
  };

  const handleTakeAllCamels = () => {
    if (!disabled) {
      takeAllCamels();
      clearSelection();
    }
  };

  const handleExchange = () => {
    if (canExchange && !disabled) {
      // 检查是否从市场拿取了骆驼
      const hasMarketCamels = selectedCards.market.some(idx => {
        const card = gameState.market[idx];
        return card.type === 'camel';
      });

      if (hasMarketCamels) {
        alert('交换操作不能拿取市场中的骆驼！');
        return;
      }

      // 将手牌索引转换为类型数组
      const handCardTypes = selectedCards.hand.map(idx => gameState.self.hand[idx].type);

      exchangeCards(selectedCards.market, handCardTypes, selectedCards.camels.length);
      clearSelection();
    }
  };

  const handleSell = () => {
    if (canSell && !disabled) {
      // 获取选中的第一张卡牌的类型
      const firstCardIndex = selectedCards.hand[0];
      const cardType = gameState.self.hand[firstCardIndex].type;
      const sellCount = selectedCards.hand.length;

      // 检查是否所有选中的卡牌类型相同
      const allSameType = selectedCards.hand.every(idx =>
        gameState.self.hand[idx].type === cardType
      );

      if (!allSameType) {
        alert('出售操作只能选择相同类型的卡牌！');
        return;
      }

      // 检查贵重货物限制
      if (['diamond', 'gold', 'silver'].includes(cardType) && sellCount < 2) {
        alert('钻石、黄金、白银必须至少出售2张！');
        return;
      }

      sellCards(cardType, sellCount);
      clearSelection();
    }
  };

  return (
    <div className={`action-panel ${disabled ? 'disabled' : ''}`}>
      <h3 className="panel-title">操作</h3>

      <div className="action-group">
        <button
          className={`action-btn ${canTakeOne ? 'active' : ''}`}
          onClick={handleTakeOne}
          disabled={disabled || !canTakeOne}
          title="选择市场中的1张货物卡（不能是骆驼）"
        >
          拿取一张卡牌
        </button>

        <button
          className={`action-btn ${canTakeAllCamels ? 'active' : ''}`}
          onClick={handleTakeAllCamels}
          disabled={disabled || !canTakeAllCamels}
          title="拿取市场中的所有骆驼"
        >
          拿取所有骆驼
        </button>
      </div>

      <div className="action-group exchange-group">
        <h4>交换货物</h4>
        <p className="action-hint">
          从市场选 {selectedCards.market.length} 张，
          换出 {selectedCards.hand.length} 张手牌 + {selectedCards.camels.length} 只骆驼
        </p>
        <button
          className={`action-btn ${canExchange ? 'active' : ''}`}
          onClick={handleExchange}
          disabled={disabled || !canExchange}
          title="等量交换：从市场拿N张，必须换出N张（手牌+骆驼）"
        >
          执行交换
        </button>
      </div>

      <div className="action-group sell-group">
        <h4>出售卡牌</h4>
        {selectedCards.hand.length > 0 && (
          <p className="action-hint">
            已选择 {selectedCards.hand.length} 张卡牌
          </p>
        )}
        <button
          className={`action-btn ${canSell ? 'active' : ''}`}
          onClick={handleSell}
          disabled={disabled || !canSell}
          title="选择相同类型的卡牌进行出售"
        >
          出售卡牌
        </button>
      </div>

      <button
        className="action-btn btn-secondary"
        onClick={clearSelection}
        disabled={disabled || (selectedCards.market.length === 0 && selectedCards.hand.length === 0 && selectedCards.camels.length === 0)}
      >
        清除选择
      </button>
    </div>
  );
}

export default ActionPanel;
